import React, { Fragment, useEffect, useState } from "react"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"
import { EarthEuropeAfricaFilled20, Checkmark16 } from "@carbon/icons-react"
import { Menu, Transition } from "@headlessui/react"
import { useTranslation } from "react-i18next"

import { privacyLinks } from "../../utilities/privacy-links"

const websitesMapping = require("../../../config/websites")
const websites = websitesMapping["websitesMapping"]

const Footer = ({ navData }) => {
  const [currentWebsite, setCurrentWebsite] = useState(null)
  const [otherWebsites, setOtherWebsites] = useState(null)

  const { t, i18n } = useTranslation()

  let navColumns = []
  let lastColIndex = navData?.length - 2

  navData?.forEach((item, index) => {
    if (index === 1) {
      navColumns.push({ navItems: [navData[1], navData[2]] })
    } else if (index === lastColIndex) {
      navColumns.push({
        navItems: [navData[lastColIndex], navData[lastColIndex + 1]],
      })
    } else if (
      index !== 2 &&
      index < lastColIndex &&
      item.component === "nav_item"
    ) {
      navColumns.push({ navItems: [item] })
    }
  })

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentWebsite(
        websites.find((w) => w.url.split("/")[1] === i18n.language) || null
      )
      setOtherWebsites(websites)
    }
  }, [i18n.language])

  const openKlaro = () => {
    if (typeof window !== "undefined") {
      window?.klaro?.show({
        ...window.klaroConfig,
        ...{ lang: i18n.language },
        ...{ privacyPolicy: { default: privacyLinks[i18n.language] } },
      })
    }
  }

  return (
    <footer className="text-white bg-black">
      {/* Sitemap */}
      <div className="max-w-screen-xl mx-auto text-sm px-grid">
        <div className="flex flex-row flex-wrap py-10 -mx-grid">
          {navColumns?.map((navCol, colIndex) => {
            return (
              <div
                key={`footer-col-${colIndex}`}
                className="w-full mb-4 lg:mb-0 md:w-1/2 lg:w-1/3"
              >
                {navCol.navItems.map((item) => {
                  return (
                    <React.Fragment key={item._uid}>
                      {item.component === "nav_item" && (
                        <>
                          {item?.link?.cached_url === "" ? (
                            <p className="block px-4 pt-6 mb-2 font-bold text-white">
                              {item.title}
                            </p>
                          ) : (
                            <Link
                              className="inline-block pt-6 pl-4 pr-10 mb-2 font-bold text-white md:pr-4 hover:text-primary"
                              link={item.link.cached_url}
                            >
                              {item.title}
                            </Link>
                          )}
                          {item?.sub_navigation.length > 0 &&
                            item.sub_navigation.map((subItem, innerindex) => {
                              return (
                                <div key={innerindex}>
                                  <Link
                                    className="inline-block py-2 pl-4 pr-10 md:pr-4 hover:text-primary"
                                    link={subItem.link.cached_url}
                                  >
                                    {subItem.title}
                                  </Link>
                                </div>
                              )
                            })}
                        </>
                      )}
                    </React.Fragment>
                  )
                })}
                {colIndex === 2 && currentWebsite !== null && (
                  <Menu as="div" className="relative mt-8 bg-ruko-gray">
                    {({ open }) => (
                      <>
                        <Menu.Button
                          className={`btn block w-full text-left text-white hover:text-white ${
                            open ? "text-white" : ""
                          }`}
                        >
                          {currentWebsite && currentWebsite.title}
                          <EarthEuropeAfricaFilled20 className="absolute inline-block align-middle right-4 top-3.5" />
                        </Menu.Button>
                        <Transition
                          as={Fragment}
                          enter="transition duration-100 ease-out"
                          enterFrom="transform scale-50 opacity-0"
                          enterTo="transform scale-100 opacity-100"
                          leave="transition duration-75 ease-out"
                          leaveFrom="transform scale-100 opacity-100"
                          leaveTo="transform scale-50 opacity-0"
                        >
                          <Menu.Items
                            as="ul"
                            className="absolute left-0 right-auto z-50 h-64 min-w-full px-4 overflow-y-scroll shadow-lg bg-ruko-gray origin-bottom-center bottom-full whitespace-nowrap"
                          >
                            {otherWebsites?.length > 0 &&
                              otherWebsites.map((w) => (
                                <Menu.Item as="li" key={w.url}>
                                  <Link
                                    className={`block relative px-0 border-b btn hover:text-white border-gray-400${
                                      w.url === currentWebsite.url
                                        ? " text-primary"
                                        : " text-white"
                                    }`}
                                    link={w.url}
                                    isCrossWebsiteLink={true}
                                  >
                                    {w.title}
                                    {w.url === currentWebsite.url && (
                                      <Checkmark16 className="inline-block ml-2 mt-0.5 align-middle absolute right-0" />
                                    )}
                                  </Link>
                                </Menu.Item>
                              ))}
                          </Menu.Items>
                        </Transition>
                      </>
                    )}
                  </Menu>
                )}
              </div>
            )
          })}
        </div>
        <div className="w-full border-t border-gray-400 px-grid" />
        {/* Meta-Nav */}
        <div className="flex flex-row flex-wrap justify-between py-4 text-xs -mx-grid">
          <div className="flex flex-row flex-wrap w-full xl:w-auto">
            <button
              className="py-4 px-grid hover:text-primary whitespace-nowrap"
              onClick={() => {
                openKlaro()
              }}
            >
              {t("generic.user_consent.manage_cookies")}
            </button>
            {navData?.map((item, index) => {
              return (
                <Fragment key={index}>
                  {item?.content?.map((content, index) => {
                    return (
                      <Link
                        key={index}
                        className="py-4 px-grid hover:text-primary whitespace-nowrap"
                        link={content.link.cached_url}
                      >
                        {content.title}
                      </Link>
                    )
                  })}
                </Fragment>
              )
            })}
          </div>
          <span className="block w-full py-4 px-grid xl:order-first xl:w-auto">
            © {new Date().getFullYear()} RUKO GmbH Präzisionswerkzeuge
          </span>
        </div>
      </div>
    </footer>
  )
}

export default Footer
